<script lang="ts" setup>
defineOptions({
    name: 'Choice'
});

const { $t } = useLocalization();

interface ChoiceOption
{
    value: any;
    text: string;
    title?: string;
}

const props = withDefaults(defineProps<{
    modelValue?: any;
    options?: ChoiceOption[];
    label?: string;
    defaultOptions?: string[];
}>(), {
    modelValue: undefined,
    options: () => [],
    label: '',
    defaultOptions: undefined
});

const emit = defineEmits<{
    (e: 'update:modelValue', value: any): void;
}>();

const filteredOptions = computed(() =>
{
    if (!props.defaultOptions || props.defaultOptions.length === 0)
    {
        return props.options;
    }

    // Filtruj opcje i sortuj je według kolejności w defaultOptions
    const filtered = props.options.filter(option =>
        props.defaultOptions?.includes(option.value)
    );

    // Sortuj według kolejności w defaultOptions
    return filtered.sort((a, b) =>
    {
        const indexA = props.defaultOptions!.indexOf(a.value);
        const indexB = props.defaultOptions!.indexOf(b.value);

        return indexA - indexB;
    });
});

const update = (value: any): void =>
{
    emit('update:modelValue', value);
};
</script>

<template>
    <div class="form-group">
        <label v-if="label">{{ $t(label) }}</label>
        <div>
            <div class="btn-group w-100">
                <button
                    v-for="option in filteredOptions"
                    :key="option.value"
                    class="text-truncate"
                    type="button"
                    :class="{
                        'btn btn-primary': option.value === props.modelValue,
                        'btn btn-light': option.value !== props.modelValue,
                    }"
                    :title="option.title ? $t(option.title) : $t(option.text)"
                    @click="update(option.value)"
                >
                    {{ $t(option.text) }}
                </button>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.btn {
    text-transform: inherit;
    font-weight: normal;
    padding: 0.25rem;
}
</style>
